import { createReducer, on } from "@ngrx/store";
import { IFuncionario } from "src/app/shared/interfaces/funcionario/ifuncionario";
import { funcionarioActions } from "./funcionario.actions";

export interface IFuncionarioState {
    lista: IFuncionario[];
    isLoading: boolean,
    type: string,
    action: string
}

const initialState: IFuncionarioState = {
    lista: [],
    isLoading: false,
    type: '',
    action: ''
}

export const funcionarioReducer = createReducer(
    initialState,
    on(funcionarioActions.loadFuncionario, (state) => ({
        ...state,
        type: 'loading',
        action: 'get'
    })),

    on(
        funcionarioActions.loadFuncionarioSuccess,
        (state, { lista }) => ({
            ...state,
            lista: [...lista],
            type: 'success',
            action: 'get'
        })

    ),

    on(funcionarioActions.loadFuncionarioError, (state) => ({
        ...state,
        type: 'error',
        action: 'get'
    })),

    on(funcionarioActions.saveFuncionarioSuccess, (state) => ({
        ...state,
        type: 'success',
        action: 'save'
    })),
    on(funcionarioActions.saveFuncionario, (state) => ({
        ...state,
        type: 'loading',
        action: 'save'
    })),
    on(funcionarioActions.saveFuncionarioError, (state) => ({
        ...state,
        type: 'error',
        action: 'save'
    })),

    on(funcionarioActions.editFuncionario, (state) => ({
        ...state,
        type: 'loading',
        action: 'edit'
    })),

    on(funcionarioActions.editFuncionarioSuccess, (state) => ({
        ...state,
        type: 'success',
        action: 'edit'
    })),
    on(funcionarioActions.editFuncionarioError, (state) => ({
        ...state,
        type: 'error',
        action: 'edit'
    }))
)